<!-- TODO: refactor to unify with `/components/Shows/Episodes/EpisodesListNav.vue` -->
<template>
    <nav class="add-episode-nav">
        <ul class="nav-items">
            <li
                v-for="(item, key) in items"
                :key="key"
                class="nav-item"
            >
                <a
                    href="#"
                    class="nav-link"
                    :class="{
                        active: tab === key,
                        disabled: item.disabled
                    }"
                    @click.prevent="changeTab(item, key)"
                >
                    <i
                        class="nav-link-icon"
                        :class="`far fa-${item.icon}`"
                    />
                    {{ item.label }}
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>
import { mapState } from 'vuex';

export default {
    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        value: {
            required: true,
            type: String,
        },
    },

    computed: {
        ...mapState({
            context: state => state.UIState.addEpisodeModal.context,
        }),

        /**
         * Returns list of nav items.
         *
         * @returns {object} Nav items.
         */
        items() {
            return {
                details: {
                    icon: 'volume-up',
                    label: 'Episode Details',
                    disabled: false,
                },
                share: {
                    icon: 'share-alt',
                    label: 'Share',
                    disabled: 'edit' !== this.context,
                },
                transcript: {
                    icon: 'file-alt',
                    label: 'Transcript',
                    disabled: false,
                },
            };
        },

        tab: {
            /**
             * Gets tab value.
             *
             * @returns {string|null} Tab value.
             */
            get() {
                return this.value;
            },

            /**
             * Sets tab value.
             *
             * @param {string} value Tab value.
             */
            set(value) {
                this.$emit('change', value);
            },
        },
    },

    methods: {
        /**
         * Changes current tab.
         *
         * @param  {object} item Nav item.
         * @param  {string} key  Nav key.
         */
        changeTab(item, key) {
            if (! item.disabled) {
                this.tab = key;
            }
        },
    },
};
</script>
